export const GET_PROVIDERS = 'GET_PROVIDERS';
export const GET_ACTIVE_USERS = 'GET_ACTIVE_USERS';
export const GET_OFFERS_TO_CUSTOMERS = 'GET_OFFERS_TO_CUSTOMERS';
export const GET_MESSAGES_FROM_CUSTOMERS = 'GET_MESSAGES_FROM_CUSTOMERS';
export const GET_CONVERSION = 'GET_CONVERSION';
export const GET_OFFERS_CONVERTED = 'GET_OFFERS_CONVERTED';
export const GET_GMV = 'GET_GMV';